//The contents of this file have been generated automatically. Do not edit this file.

import * as t from 'io-ts';
import { isRight } from 'fp-ts/lib/Either';
import { fetchGeneralRaw, FetchGeneralRawResponseType } from 'src_common/common/fetch';
import { ApiTimeLog } from 'src_common/server/webDriver/logFormat';


export interface ParamsType {
    universe: string;
}


const createGuard = <A>(code: number, decoder: t.Type<A, A, unknown>): ((data: unknown) => A) => {
    return (data: unknown): A => {
        const decodeResult = decoder.decode(data);
        if (isRight(decodeResult)) {
            return decodeResult.right;
        }
        throw Error(`Response decoding error /website-cms/{universe}/landing/landing_promo_page -> get -> ${code}`);
    };
};

export const Response200IO = t.array(t.interface({
    action_template: t.string,
    banner_type: t.string,
    cta_text: t.string,
    cta_url: t.string,
    date_from: t.string,
    date_to: t.string,
    details: t.unknown,
    id: t.number,
    img_html_url: t.union([t.null, t.undefined, t.string]),
    img_url: t.union([t.null, t.undefined, t.string]),
    is_active: t.boolean,
    is_homepage: t.boolean,
    promo_code: t.string,
    show_frequency: t.string,
    slug: t.string,
    tc_text: t.string,
    title: t.string,
    universe: t.string,
}));
export type Response200Type = Array<{
    action_template: string;
    banner_type: string;
    cta_text: string;
    cta_url: string;
    date_from: string;
    date_to: string;
    details: unknown;
    id: number;
    img_html_url?: null | undefined | string;
    img_url?: null | undefined | string;
    is_active: boolean;
    is_homepage: boolean;
    promo_code: string;
    show_frequency: string;
    slug: string;
    tc_text: string;
    title: string;
    universe: string;
}>;
export const decodeResponse200 = createGuard(200, Response200IO);

export const Response500IO = t.unknown;
export type Response500Type = unknown;
export const decodeResponse500 = createGuard(500, Response500IO);



type ExtraHeadersType = Record<string, string>


/**
 * @deprecated - Please use this method "openapiWebsiteCmsGetLandingPageListRequest"
 */
export const openapi_website_cms_getLandingPageList = async (api_url: string, api_timeout: number, backendToken: string, params: ParamsType, extraHeaders?: ExtraHeadersType): Promise<FetchGeneralRawResponseType> => {
    
        
    const query = '';
    const url = `${api_url}/website-cms/${params.universe}/landing/landing_promo_page${query}`;
    
    const method = 'GET';
    const paramsFetch = {
        url,
        body: undefined,
        backendToken,
        timeout: api_timeout,
        extraHeaders,
    };

    const apiTime = ApiTimeLog.createWithProcessEnv(method, url);
    const response = await fetchGeneralRaw(method, paramsFetch);
    apiTime.show(response.status);
    return response;
};


export type OpenapiWebsiteCmsGetLandingPageListParamsType = ParamsType;

export type OpenapiWebsiteCmsGetLandingPageListResponseType = {
    status: 200;
    body: Response200Type;
} | {
    status: 500;
    body: Response500Type;
};

export type OpenapiWebsiteCmsGetLandingPageListResponse200Type = Response200Type;

export const openapiWebsiteCmsGetLandingPageListRequest = async (api_url: string, api_timeout: number, backendToken: string, params: ParamsType, extraHeaders?: ExtraHeadersType): Promise<OpenapiWebsiteCmsGetLandingPageListResponseType> => {
    const response = await openapi_website_cms_getLandingPageList(api_url, api_timeout, backendToken, params, extraHeaders);
    const { status, body } = response;

    let json = null;

    try {
        json = JSON.parse(body);
    } catch (_err) {
        console.warn(`Http status ${status} - json was expected`);
        json = {};
    }
    
    if (status === 200) {
        return { status: 200, body: decodeResponse200(json) };
    }

    if (status === 500) {
        return { status: 500, body: decodeResponse500(json) };
    }

    throw new Error(`openapiWebsiteCmsGetLandingPageListRequest - unhandled response ${response.status}`);
};

